export enum ContentStatus {
  draft = "draft",
  live = "live",
  rejected = "rejected",
}
